<div class="local-container">
  <div class="full-height-column">
    <mat-card>
      <mat-toolbar>
        <app-toolbar-directory #toolbarDirectory [selectedPackagingPartTab]="selectedPackagingPartTab"
          [selectedEntriesCount]="selectedEntryIds.length" [isAddEditAllowed]="directoryPermissions.write"
          [isEnterQuantitiesAllowed]="isEnterQuantitiesAllowed" [isComparisonAllowed]="directoryPermissions.analyze"
          [isRecyclingBinSelected]="isRecyclingBinSelected" [selectedDtoFolder]="selectedDtoFolder"
          [rootDtoFolder]="rootDtoFolder" (moveClicked)="movePackagingPart()" (copyClicked)="copyPackagingPart()"
          (exportClicked)="exportPackagingPart()" (deleteClicked)="deletePackagingPart()"
          (createDataExchangeRequestClicked)="createDataExchangeRequest()"
          (restoreClicked)="restorePackagingPart()" (compareClicked)="comparePackagingPart()"
          (editQuantityClicked)="editPackagingPartQuantity()" (folderUpdated)="updateView()"
          (folderRemoved)="afterFolderRemoved()" (editTagsClicked)="editTags()" (addTagsClicked)="addTags()" (downloadJsonClicked)="downloadJson()"
          (downloadExcelClicked)="downloadEXCEL()"
          (createDocClicked)="createDoc()"
          (createTechnicalDocumentationClicked)="createTechnicalDoc()"
          >
        </app-toolbar-directory>
      </mat-toolbar>
    </mat-card>

    <div class="full-height-row flex-row">
      <mat-card class="treeview-container">
        <app-directory-tree [rootFolder]="rootDtoFolder" [contextMenu]="contextMenu" [selectedFolderId]="initialFolderId"
          (folderSelected)="onFolderSelected($event)">
        </app-directory-tree>
      </mat-card>
      <mat-card class="details-container">
        <div *ngIf="selectedDtoFolder" class="table-div">
          <div class="local-scrolling-wrapper">
            <mat-tab-group [(selectedIndex)]="selectedPackagingPartTab" (selectedTabChange)="onTabChanged()">
              <mat-tab label="{{ 'packagingSystem.packagingSystems' | transloco }}">
                <app-packaging-systems-overview [dataSource]="packagingSystemsDataSource" [allTags]="allTags"
                  [displayedColumns]="displayedColumnsPackagingSystems"
                  [isRecyclingBinSelected]="isRecyclingBinSelected"
                  (packagingPartsSelected)="packagingEntriesSelected($event)" [directoryId]="selectedDtoFolder.id">
                </app-packaging-systems-overview>
              </mat-tab>
              <mat-tab label="{{ 'packagingUnit.packagingUnits' | transloco }}">
                <app-packaging-units-overview [dataSource]="packagingUnitsDataSource" [allTags]="allTags"
                  [displayedColumns]="displayedColumnsPackagingUnits" [isRecyclingBinSelected]="isRecyclingBinSelected"
                  (packagingPartsSelected)="packagingEntriesSelected($event)" [directoryId]="selectedDtoFolder.id">
                </app-packaging-units-overview>
              </mat-tab>
              <mat-tab label="{{ 'component.packagingComponents' | transloco }}">
                <app-packaging-components-overview [dataSource]="componentsDataSource" [allTags]="allTags"
                  [displayedColumns]="displayedColumnsComponents" [isRecyclingBinSelected]="isRecyclingBinSelected"
                  (packagingPartsSelected)="packagingEntriesSelected($event)" [directoryId]="selectedDtoFolder.id">
                </app-packaging-components-overview>
              </mat-tab>
              <mat-tab label="{{ 'material.compositeMaterials' | transloco }}">
                <app-composite-materials-overview [dataSource]="materialsDataSource" [allTags]="allTags"
                  [displayedColumns]="displayedColumnsMaterials" [isRecyclingBinSelected]="isRecyclingBinSelected"
                  (packagingPartsSelected)="packagingEntriesSelected($event)" [directoryId]="selectedDtoFolder.id">
                </app-composite-materials-overview>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <ng-template #contextMenu let-item>
    <mat-card class="context-menu">
      <div *ngIf="item.id !== recyclingBinId && directoryPermissions?.write"
        [matMenuTriggerFor]="toolbarDirectory.createMenu">
        {{ 'dataManagement.directory.toolbar.create.button' | transloco }}...
      </div>
      <div *ngIf="item.id !== rootDtoFolder.id && item.id !== recyclingBinId" (click)="removeFolder()">
        {{ 'dataManagement.directory.toolbar.removeFolderButton' | transloco }}
      </div>
      <div *ngIf="item.id !== rootDtoFolder.id && item.id !== recyclingBinId" (click)="renameFolder()">
        {{ 'dataManagement.directory.toolbar.renameFolderButton' | transloco }}
      </div>
      <div *ngIf="item.id !== rootDtoFolder.id && item.id !== recyclingBinId" (click)="moveFolder()">
        {{ 'dataManagement.directory.toolbar.moveFolderButton' | transloco }}
      </div>
      <div *ngIf="item.id === recyclingBinId" (click)="emptyRecyclingBin()">
        {{ 'dataManagement.directory.toolbar.contextMenu.emptyBin' | transloco }}
      </div>
      <div *ngIf="item.id === recyclingBinId" (click)="restoreAllItemsFromRecyclingBin()">
        {{ 'dataManagement.directory.toolbar.contextMenu.restoreAll' | transloco }}
      </div>
    </mat-card>
  </ng-template>
</div>
